/* eslint-disable */
import React from 'react';
import Link from 'next/link';
import { BsDot } from 'react-icons/bs';
import colors from 'utils/colors';
import { useRouter } from 'next/router';

function RecentPost({ data, language }) {
  const router = useRouter();
  const pathname = router.asPath.split('/');

  return (
    <div
      style={{
        background: colors.blue1,
        borderRadius: '15px',
        padding: '17px 22px'
      }}
    >
      <span style={{ color: 'white', fontWeight: '600' }}>
        {language === 'EN' ? 'Recent Post' : 'Posting Terbaru'}
      </span>

      <div style={{ marginTop: '5px' }}>
        {data?.map((item, index) => (
          <Link
            href={
              language === 'EN'
                ? item.en_slug && '/' + 'blogs/detail/' + item.en_slug
                : item.id_slug && '/' + 'blogs/detail/' + item.id_slug
            }
            locale={language === 'ID' ? 'id' : 'en'}
          >
            <ul
              className="m-0 recent-post-details"
              key={index}
              style={{ color: 'white', cursor: 'pointer' }}
            >
              <li>
                <span
                  style={{ fontWeight: '600' }}
                  dangerouslySetInnerHTML={{
                    __html: language === 'EN' ? item.en_title : item.id_title
                  }}
                ></span>
              </li>
            </ul>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default RecentPost;
